var _G, _Defs;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";
import Svg, { G, Path, Defs, ClipPath } from "react-native-svg";

function SvgPowerIcon(props) {
  return /*#__PURE__*/React.createElement(Svg, _extends({
    width: 33,
    height: 33,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _G || (_G = /*#__PURE__*/React.createElement(G, {
    clipPath: "url(#power-icon_svg__clip0_3291_2950)"
  }, /*#__PURE__*/React.createElement(Path, {
    d: "M16.86 6.951a2.239 2.239 0 00-2.336 1.117 2.262 2.262 0 00.37 2.7c.364.366.843.595 1.356.649a2.239 2.239 0 002.255-1.275 2.266 2.266 0 00-.44-2.562 2.243 2.243 0 00-1.205-.629z"
  }), /*#__PURE__*/React.createElement(Path, {
    d: "M3.802 3.44h1.4V8.68H7.01V3.44h18.98v5.242h1.807V3.44h1.401a.904.904 0 100-1.807H3.802a.904.904 0 100 1.807z"
  }), /*#__PURE__*/React.createElement(Path, {
    d: "M21.73 12.582c.46.012.886-.25 1.083-.666l.024-.051.3-.472h-4.418a3.154 3.154 0 00.88-1.807h9.327V6.444c0-.49.381-.907.871-.925a.904.904 0 01.937.903v1.993c.457.046.813.431.813.9v2.417a.904.904 0 01-.813.9v1.97c0 .49-.381.908-.87.926a.904.904 0 01-.938-.904v-3.23h-1.13v19.973H25.99V11.393h-.711l-.858 1.35a2.974 2.974 0 01-2.66 1.647l-.073-.001-2.236-.033.001.064v7.272l.648 8.32a1.257 1.257 0 11-2.507.195l-.602-7.74a.513.513 0 00-1.024 0l-.603 7.74a1.257 1.257 0 01-2.507-.196l.648-8.319V14.42v-.048l-2.194.032-.072.001a2.973 2.973 0 01-2.683-1.692l-.659-1.32h-.888v19.973H5.202V11.393h-1.13v3.21c0 .49-.38.907-.87.925a.904.904 0 01-.937-.904v-1.992a.904.904 0 01-.814-.9V9.315c0-.469.357-.854.814-.9v-1.97c0-.49.38-.908.87-.926a.904.904 0 01.937.903v3.164h9.286c.09.68.4 1.318.882 1.807H9.917l.269.538c.07.15.23.277.406.38.333.193.714.287 1.098.287l10.039-.015z"
  }))), _Defs || (_Defs = /*#__PURE__*/React.createElement(Defs, null, /*#__PURE__*/React.createElement(ClipPath, {
    id: "power-icon_svg__clip0_3291_2950"
  }, /*#__PURE__*/React.createElement(Path, {
    fill: "#fff",
    transform: "translate(1 1)",
    d: "M0 0h31v31H0z"
  })))));
}

export default SvgPowerIcon;